import request from '@/api/utils/request'

// 记录当前用户今天第一次登录时间
export function addUserLoginLog() {
  return request({
    url: '/api/user_login_log/add',
    method: 'POST'
  })
}
